export const CREATE_ROLE_ACTION = '[Role Action] Create Role';
export const CONFIRMED_CREATE_ROLE_ACTION = '[Role Action] Confirmed Create Role';
export const CREATE_ROLE_ERROR_ACTION='[Role Action] Create Role Error';
export const GET_ROLES = '[Role Action] Get Roles';
export const CONFIRMED_GET_ROLES = '[Role Action] Confirmed Get Roles';
export const LOADING_ROLES = '[Role Action] Loading for Roles';
export const EDIT_ROLE_ACTION = '[Role Action] Edit Role';
export const CONFIRMED_EDIT_ROLE_ACTION = '[Role Action] Confirmed Edit Role';
export const DELETE_ROLE_ACTION = '[Role Action] Delete Role';
export const CONFIRMED_DELETE_ROLE_ACTION = '[Role Action] Confirmed Delete Role';
export const ROLE_ERROR_ACTION = '[Role Action] Error';
export const CLEAR_ROLE_ERROR = '[Role Action] Clear Error';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const CONFIRMED_GET_ROLE_PERMISSIONS = '[Role permission action] Get permission';



